import { c as _c } from "react/compiler-runtime";
import { useAtomCallback } from 'jotai/utils';
import { toast } from 'sonner';
import type { TrackedWord } from '@/app/[locale]/(vocabulary)/_lib/LexiconTrie';
import { userWordPhaseMutationAtom } from '@/app/[locale]/(vocabulary)/_api';
import { userAtom } from '@/atoms/auth';
import { LoginToast } from '@/components/login-toast';
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from '@/components/ui/alert-dialog';
import { useI18n } from '@/locales/client';
export function AcquaintAllDialog(t0) {
  const $ = _c(40);
  const {
    vocabulary
  } = t0;
  const t = useI18n();
  const acquaintAllVocab = useAtomCallback(_temp);
  let T0;
  let T1;
  let T2;
  let T3;
  let rowsToRetain;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t || $[1] !== vocabulary) {
    rowsToRetain = vocabulary.filter(_temp2);
    const count = rowsToRetain.length;
    T3 = AlertDialog;
    let t5;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <svg className="icon-[solar--list-check-bold]" />;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== t) {
      t6 = t("acquaintedAll");
      $[12] = t;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    if ($[14] !== t6) {
      t4 = <AlertDialogTrigger nativeButton={false} render={<div className="flex w-full flex-row items-center gap-3 px-2 py-1.5">{t5}<div className="">{t6}</div></div>} />;
      $[14] = t6;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    T2 = AlertDialogContent;
    t3 = "sm:max-w-106.25";
    T1 = AlertDialogHeader;
    let t7;
    if ($[16] !== t) {
      t7 = t("acquaintedAll");
      $[16] = t;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    if ($[18] !== t7) {
      t2 = <AlertDialogTitle>{t7}</AlertDialogTitle>;
      $[18] = t7;
      $[19] = t2;
    } else {
      t2 = $[19];
    }
    T0 = AlertDialogDescription;
    t1 = t("acquaintedAllConfirmText", {
      count
    });
    $[0] = t;
    $[1] = vocabulary;
    $[2] = T0;
    $[3] = T1;
    $[4] = T2;
    $[5] = T3;
    $[6] = rowsToRetain;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    T0 = $[2];
    T1 = $[3];
    T2 = $[4];
    T3 = $[5];
    rowsToRetain = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
  }
  let t5;
  if ($[20] !== T0 || $[21] !== t1) {
    t5 = <T0>{t1}</T0>;
    $[20] = T0;
    $[21] = t1;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== T1 || $[24] !== t2 || $[25] !== t5) {
    t6 = <T1>{t2}{t5}</T1>;
    $[23] = T1;
    $[24] = t2;
    $[25] = t5;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  let t7;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <AlertDialogCancel>Cancel</AlertDialogCancel>;
    $[27] = t7;
  } else {
    t7 = $[27];
  }
  let t8;
  if ($[28] !== acquaintAllVocab || $[29] !== rowsToRetain) {
    t8 = <AlertDialogFooter className="">{t7}<AlertDialogAction onClick={() => {
        if (rowsToRetain.length > 0) {
          acquaintAllVocab(rowsToRetain);
        }
      }}>Continue</AlertDialogAction></AlertDialogFooter>;
    $[28] = acquaintAllVocab;
    $[29] = rowsToRetain;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== T2 || $[32] !== t3 || $[33] !== t6 || $[34] !== t8) {
    t9 = <T2 className={t3}>{t6}{t8}</T2>;
    $[31] = T2;
    $[32] = t3;
    $[33] = t6;
    $[34] = t8;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] !== T3 || $[37] !== t4 || $[38] !== t9) {
    t10 = <T3>{t4}{t9}</T3>;
    $[36] = T3;
    $[37] = t4;
    $[38] = t9;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  return t10;
}
function _temp2(row) {
  return row.form.length <= 32;
}
function _temp(get, _, rows) {
  if (!get(userAtom)) {
    toast(<LoginToast />);
    return;
  }
  get(userWordPhaseMutationAtom).mutateAsync(rows).catch(console.error);
}